import { IDVerificationType } from "@/types/IDVerificationType";
import { useMemo } from "react";
import useSWR from "@/hooks/useSWR";
import { useVerificationFlow } from "./useVerificationFlow";
import {
  canRetryIdVerification,
  shouldContactSupport,
} from "@/components/IdVerification/helpers";

export default function useIdVerificationStatus() {
  const { data: verification } = useSWR<IDVerificationType>("/idverification/");

  const { data: { results } = {} } = useVerificationFlow({
    state: "inflow",
    flowType__in: ["acceptable_use_violation", "fraudulent_payment"],
  });

  const needsIdVerification = useMemo(
    () =>
      results?.some((item) => item.id_verification_required) &&
      verification?.state === "requested",
    [results, verification]
  );

  const { state } = verification || {};

  const _state = needsIdVerification ? "required" : state;

  return useMemo(() => {
    const getStatus = () => {
      return _state ?? null;
    };

    const status = getStatus();

    const allowRetry = canRetryIdVerification(verification);
    const contactSupport = shouldContactSupport(verification);

    return {
      status,
      allowRetry,
      contactSupport,
      updated_at: verification?.updated_at,
    };
  }, [verification, _state]);
}
